module.exports = __webpack_public_path__ + "img/tracker-icon-dark.5857ad5a.svg";